/**
 * WordPress dependencies
 */
import {
	store,
	getElement,
	getContext,
	withScope,
} from '@wordpress/interactivity';

function getOffset(side, element, curve, totalSlides) {
	if (!element) {
		return 0;
	}
	const size = element.getAttribute('data-size');
	if (!curve[size]) {
		return 0;
	}
	let offset;
	if (size === 'small') {
		const spacing = curve[size].getTotalLength() / (totalSlides + 1);
		offset = curve[size].getPointAtLength(
			(parseInt(element.getAttribute('data-position'), 10) + 1) * spacing
		);
	}

	if (size === 'big') {
		const spacing =
			(curve[size].getTotalLength() * 0.6) / (totalSlides + 1);
		offset = curve[size].getPointAtLength(
			curve[size].getTotalLength() * 0.2 +
				(parseInt(element.getAttribute('data-position'), 10) + 1) *
					spacing
		);
	}

	return side === 'left' ? offset.x : offset.y;
}

const { state, actions } = store('gems-blocks/slider', {
	state: {
		get noPrevSlide() {
			const ctx = getContext();
			if (ctx.continuous) {
				return false;
			}
			return ctx.currentSlide === 0;
		},
		get noNextSlide() {
			const ctx = getContext();
			if (ctx.continuous) {
				return false;
			}
			return ctx.currentSlide === ctx.totalSlides - 1;
		},
		get currentPos() {
			const ctx = getContext();
			return `translateX(-${ctx.currentSlide * 100}%)`;
		},
		get transitionsSpeed() {
			const ctx = getContext();
			return Number(ctx.speed) * 1000;
		},
		get isActiveSlide() {
			const ctx = getContext();
			const { ref } = getElement();
			return ctx.currentSlide === ctx.slides.indexOf(ref);
		},
		get offsetLeft() {
			const { curve, totalSlides } = getContext();
			const { ref } = getElement();
			return getOffset('left', ref, curve, totalSlides);
		},
		get offsetTop() {
			const { curve, totalSlides } = getContext();
			const { ref } = getElement();

			return getOffset('top', ref, curve, totalSlides);
		},
		get isDotActive() {
			const { currentSlide, totalSlides } = getContext();
			const { ref } = getElement();
			if (!ref) return false;
			return currentSlide == ref.getAttribute('data-position');
		},
	},
	actions: {
		focusSlide: () => {
			const ctx = getContext();
			const { ref } = getElement();
			// Get the index of the clicked slide
			ctx.currentSlide = ctx.slides.indexOf(ref);
		},
		goToSlide: () => {
			const ctx = getContext();
			const { ref } = getElement();
			ctx.currentSlide = ref.getAttribute('data-position');
			clearInterval(ctx.autoplayInterval);
			ctx.autoplay = false;
		},
		prevImage: () => {
			const ctx = getContext();
			if (ctx.continuous && ctx.currentSlide === 0) {
				ctx.currentSlide = ctx.totalSlides - 1;
				return;
			}
			ctx.currentSlide--;
		},
		nextImage: () => {
			const ctx = getContext();
			if (
				(ctx.continuous || ctx.autoplay) &&
				ctx.currentSlide === ctx.totalSlides - 1
			) {
				ctx.currentSlide = 0;
				return;
			}
			ctx.currentSlide++;
		},
		onTouchStart: (e) => {
			const ctx = getContext();
			ctx.swipe = e.changedTouches[0].clientX;
		},
		onTouchEnd: (e) => {
			const ctx = getContext();
			if (e.changedTouches[0].clientX < ctx.swipe) {
				if (!state.noNextSlide) {
					actions.nextImage();
				}
			} else {
				if (!state.noPrevSlide) {
					actions.prevImage();
				}
			}
			ctx.swipe = null;
		},
	},
	callbacks: {
		initSlideShow: () => {
			const ctx = getContext();
			if (ctx.autoplay) {
				ctx.autoplayInterval = setInterval(
					withScope(() => {
						actions.nextImage();
					}),
					state.transitionsSpeed
				);
			}
		},
		initSlide: () => {
			const ctx = getContext();
			const { ref } = getElement();
			ctx.slides.push(ref);
			ctx.totalSlides = ctx.slides.length;

			return () => {
				ctx.slides = ctx.slides.filter((s) => s !== ref);
			};
		},
		initCurve: () => {
			const ctx = getContext();
			const { ref } = getElement();
			const size = ref.getAttribute('data-size');
			ctx.curve = ctx.curve ?? {};
			ctx.curve[size] = ref;
		},
	},
});
